import { render, staticRenderFns } from "./AdminUserProfile.vue?vue&type=template&id=40d04174&scoped=true"
import script from "./AdminUserProfile.vue?vue&type=script&lang=js"
export * from "./AdminUserProfile.vue?vue&type=script&lang=js"
import style0 from "./AdminUserProfile.vue?vue&type=style&index=0&id=40d04174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d04174",
  null
  
)

export default component.exports